export default "__VITE_PUBLIC_ASSET__a75f0448__"